export default __webpack_public_path__ + "static/media/IND-1.9c726236.jpg";